import type { PaginationParams, TemplateConfigurationStatus } from '@klareospace/pharos-lib-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface SearchTemplateConfigurationsParams extends PaginationParams {
  search?: string;
  statuses: TemplateConfigurationStatus[];
}

// ─── Query Key Factory ────────────────────────────────────────────────────────

export const templateConfigurationKeys = {
  all: ['template-configurations'] as const,
  detail: (id: string) => [...templateConfigurationKeys.all, 'detail', id] as const,
  lists: () => [...templateConfigurationKeys.all, 'list'] as const,
  search: (params: SearchTemplateConfigurationsParams) =>
    [...templateConfigurationKeys.lists(), 'search', params] as const,
};
